export default "__VITE_ASSET__Bzu_HsiT__"